<template>
  <div id="installation" class="page">
    <section class="page-title">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <ol class="breadcrumb">
              <li>
                <router-link to="/">Accueil</router-link>
              </li>
              <li>Qualité d'inox</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
    <div class="container">
      <div class="row">
        <div class="col-md-8">
          <section class="faq-pg-section section-padding-50">
            <div class="row">
              <div class="col-md-12">
                <div class="section-title-s4">
                  <h1>Les inox <div>304 et 316</div></h1>
                </div>
                <h2>Qu'est ce que l'inox ?</h2>
                <p>
                  L'inox est un métal constitué de divers éléments d'alliage. Le principal élément d'alliage est le fer (plus de 50%), c'est la base de l'acier inoxydable.
                </p>
                <p>
                  Les autres éléments ont également leur fonction propre : le nickel assure la stabilité et la solidité, le chrome la résistance à la rouille et le molybdène une résistance supplémentaire à la rouille dans des conditions extrêmes comme des endroits fortement pollués.
                </p>
                <h2>Les différents types d'inox : inox 304 et inox 316</h2>
                <p>
                  Il existe 2 types importants d'Inox : <strong>lnox 304</strong> dans lequel le nickel et le chrome sont additionnés, et <strong>l'Inox 316</strong> dans lequel on a également ajouté du molybdène (2 à 3%) pour une résistance à la corrosion supplémentaire. Les 2 types apportent une fine couche d'oxyde de chrome et éventuellement d'oxyde de molybdène comme protection anti-rouille. Ce film d'oxyde de chrome se forme spontanément par une exposition de l'acier inoxydable à l'air et forme une dure couche qui protège le métal contre la rouille.
                </p>
                <div></div>
              </div>
            </div>
          </section>
          <section class="offer-section section-padding-50">
            <div class="row">
              <div class="col col-md-6">
                <div class="section-title-s3">
                  <h3>L'inox 304 - garde corps intérieur et balustrade inox en milieu sec</h3>
                </div>
                <div class="offer-text">
                  <p><strong>Les produits en Inox 304</strong> : sont <strong>utilisables à l'intérieur et à l'extérieur</strong>, mais ne doivent <strong><u>pas</u> être posés dans une atmosphère polluée</strong> (Zone industrielle, portuaire, piscine, industrie chimique, étable et..).</p>
                  <p>Le lieu de votre projet doit être situé à plus de 50km des cotes et le taux d'humidité doit rester faible.</p>
                </div>
              </div>
              <div class="col col-md-6">
                <div class="offer-pic">
                  <img src="/static/images/Inox/logo_inox_304.png" alt="inox 304 pour garde-corp intérieur">
                </div>
              </div>
            </div>
          </section>
          <section class="offer-section section-padding-50">
            <div class="row">
              <div class="col col-md-6">
                <div class="section-title-s3">
                  <h3>L'inox 316 - garde-corps intérieur et extérieur en milieu humide</h3>
                </div>
                <div class="offer-text">
                  <p><strong>Les produits en Inox 316 </strong>: sont utilisables en <strong>milieux agressifs</strong> (bord de mer, piscine etc). </p>
                  <p>Mais attention, ceci n'exclut pas l'apparition de quelques points de rouille si votre garde-corps n'est pas entretenu régulièrement (surtout en milieux chlorés et iodés, ou si les produits sont exposés à des fortes intempéries)</p>
                  <p>Dans des environnements à haute teneur en acide chlorique ou en acide chlorhydrique ou proches de la mer, le risque de rouille persiste pour l'inox 304. Ceci est encore renforcé par la présence de sable, de vent et d'une haute humidité de l'air.</p>
                  <p>Le molybdène supplémentaire présent dans l'Inox 316 offre une meilleure protection.</p>
                </div>
              </div>
              <div class="col col-md-6">
                <div class="offer-pic">
                  <img src="/static/images/Inox/logo_inox_316.png" alt="inox 316 pour extérieur humide">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="alert alert-info">
                  <router-link to="/entretien">Vous souhaitez tout savoir sur l'entretien de l'inox ? Cliquez ici</router-link>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div class="col-md-4" style="border-left: dashed 1px #d4d4d4;margin-top: 50px;">
          <Aside/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Aside from '../Aside'

export default {
  name: 'Inox',
  components: { Aside }
}
</script>

<style scoped>
h2 {
  font-size: 22px;
  color: #025d90;
}
.offer-pic:after {
  left: 60px;
  top: 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Inox.vue